import fp from 'lodash/fp';
import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';

import { actionTypes } from './actions';


const unfoldReducer = fp.pipe(
    fp.mapValues(s => fp.isFunction(s) ? s : unfoldReducer(s)),
    combineReducers,
);

export const createRootReducer = ({ reducer }, history) => {
    const appReducer = unfoldReducer(
        fp.isEmpty(reducer)
            ? fp.identity
            : reducer,
    );

    const rootReducer = (state, action) => appReducer(
        action.type === actionTypes.CLEAR_ROOT
            ? fp.pick(['router'], state)
            : state,
        action,
    );

    return connectRouter(history)(rootReducer);
};
